import { useAuth } from "react-oidc-context";
import { Route, Redirect } from "react-router-dom";
import TokenManager from "utils/TokenManager";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const auth = useAuth();
  const loggedInUserData = localStorage.getItem("loggedInUserData");

  // While the OIDC provider is resolving the session, render nothing (avoids flash-redirect)
  if (auth.isLoading) return null;

  const isPingUser = TokenManager.isPingAuthorizationEnabled();

  const isAuthorized = auth.isAuthenticated
    ? !!loggedInUserData
    : isPingUser
      ? !!loggedInUserData // stay on page, let modal handle it
      : !!(TokenManager.get() && loggedInUserData);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthorized ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};
export default ProtectedRoute;
